export const toMinorUnits = (amount: number) => Math.round(amount * 100);
export const fromMinorUnits = (amount: number) => amount / 100;

export function formatCurrency(amount: number) {
  return `Rs. ${Math.round(amount).toLocaleString("en-PK")}`;
}
